import { Process, Step, STEP_TYPES } from "src/api/Processes";

export enum INSERT_POSITION {
    BEFORE,
    AFTER
}

export interface InsertStepIntoAllProcessesArguments {
    processes: Process[];
    stepToInsert: Step;
    referenceStepType?: STEP_TYPES;
    insertPosition: INSERT_POSITION;
}

export const insertStepIntoAllProcesses = (args: InsertStepIntoAllProcessesArguments) => {
    const { processes, stepToInsert, referenceStepType, insertPosition } = args;

    processes.forEach((process: Process) => {
        let indexOfReferenceStep = undefined;

        process.steps.forEach((step: Step, index: number) => {
            if (step.type === referenceStepType) {
                indexOfReferenceStep = index;
            }
        });

        if (indexOfReferenceStep) {
            let insertIndex;
            switch (insertPosition) {
                case INSERT_POSITION.BEFORE:
                    insertIndex = indexOfReferenceStep;
                    break;
                case INSERT_POSITION.AFTER:
                    insertIndex = indexOfReferenceStep + 1;
                    break;
            }

            process.steps.splice(insertIndex, 0, stepToInsert);
        }
    });
};
